import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=6d68716b&"
import script from "./pagenation.vue?vue&type=script&lang=js&"
export * from "./pagenation.vue?vue&type=script&lang=js&"
import style0 from "./pagenation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports